import { ExtendResponseDeadlineClaimDTOReasonTypeEnum } from '@reposit/api-client';
import { startCase, toLower } from 'lodash';
import moment from 'moment';

export const RESPONSE_DEADLINE_EXTENSION_REASON_LABELS: Record<ExtendResponseDeadlineClaimDTOReasonTypeEnum, string> = {
  [ExtendResponseDeadlineClaimDTOReasonTypeEnum.PARTNERALLOWEDMORETIME]: 'Agent or landlord agreed to more time',
  [ExtendResponseDeadlineClaimDTOReasonTypeEnum.REPOSITPROCESSFAILURE]: 'Reposit process failure',
};

// Prompts for the details box, so the free text says what an auditor would need to know for each reason.
export const RESPONSE_DEADLINE_EXTENSION_REASON_PLACEHOLDERS: Record<ExtendResponseDeadlineClaimDTOReasonTypeEnum, string> = {
  [ExtendResponseDeadlineClaimDTOReasonTypeEnum.PARTNERALLOWEDMORETIME]:
    'Who agreed and how, e.g. Sam at Acme Lettings agreed by email on 3 Nov',
  [ExtendResponseDeadlineClaimDTOReasonTypeEnum.REPOSITPROCESSFAILURE]:
    'What failed and how it affected the respondent, e.g. claim email bounced so the tenant never saw the proposal',
};

// Takes a string because the list response has its own generated enum with the same values.
export const getResponseDeadlineExtensionReasonLabel = (reasonType: string): string =>
  RESPONSE_DEADLINE_EXTENSION_REASON_LABELS[reasonType as ExtendResponseDeadlineClaimDTOReasonTypeEnum] || reasonType;

// Shared by the extend and deadline details modals.
export const formatDate = (date?: Date | string) => (date ? moment(date).format('DD/MM/YYYY') : '-');
export const formatEnum = (value: string) => startCase(toLower(value));
